import Vue from 'vue';
import VueRouter from 'vue-router';
import LoginView from '@/views/LoginView.vue';
import ClientView from '@/views/ClientView.vue';
import { inspectionRoutes, SphericalView } from '@/views';
import { authGuard } from './auth/authGuard';

Vue.use(VueRouter);

const routes = [
  {
    path: '/auth',
    component: LoginView,
  },
  {
    path: '/',
    name: 'home',
    component: ClientView,
    meta: {
      breadcrumb() {
        return {
          text: 'Dashboard',
        };
      },
    },
    beforeEnter: authGuard,
  },
  {
    path: '/client/:id',
    component: ClientView,
    beforeEnter: authGuard,
  },
  {
    path: '/spherical',
    component: SphericalView,
    beforeEnter: authGuard,
  },
  inspectionRoutes(authGuard),
];

export const router = new VueRouter({ mode: 'history', routes });
